import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { CompositeModel } from '../../models/complex/composite.model';
import { TimeZoneModel } from '../../models/complex/time-zone.model';
import { NotificationIdentifierModel } from '../../models/low-level/notification-identifier.model';
import { NotificationModel } from '../../models/low-level/notification.model';
import { TextModel } from '../../models/primitive/text.model';
import { CustomInjector } from '../../services/custom-injector/custom-injector';

import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { NotificationDataInstanceToken } from '../../interfaces/notification-data.interface';
import { NotificationUtilities } from '../../utilities/notification-utilities';

export class CancellationModel extends CompositeModel {
    public contactName: string;
    public notificationType: string; // This string used on UI
    private notificationIdentifier: NotificationIdentifierModel;
    private timeZone: TimeZoneModel;
    private notificationStatus: TextModel;
    private confirmDate: TextModel;
    private confirmTime: TextModel;
    private constructor(
        public notification: NotificationModel,
        public notificationUpdateKey: string,
        public status: NOTIFICATION_STATUS_CODE,
    ) {
        super('CancellationModel');

        // Dependency loading
        const injector = CustomInjector.getInjector();
        const notificationUtilities = injector.get(NotificationUtilities);

        // Setup model
        this.contactName = notification.address.completeName;
        this.notificationType = notificationUtilities.getNotificationTypeDescription(notification);
        this.notificationIdentifier = <NotificationIdentifierModel>this.set(notification.identifier);
        this.timeZone = <TimeZoneModel>this.set(notification.timeZone);

        this.notificationStatus = <TextModel>this.set(new TextModel('Status', status));
        this.confirmDate = <TextModel>(
            this.set(new TextModel('Date', moment().format(ConfigConstants.formatDateNoTimezone)))
        );
        this.confirmTime = <TextModel>(
            this.set(new TextModel('Time', moment().format(ConfigConstants.formatXSDTimeDuration)))
        );
    }

    public static async create(
        notificationModel: NotificationModel,
        notificationUpdateKey: string,
    ): Promise<CancellationModel> {
        const injector = CustomInjector.getInjector();
        const notificationService = injector.get(NotificationDataInstanceToken);

        const state = await notificationService.isNotificationInProgressAndCancelledAsync(notificationModel);

        let status: NOTIFICATION_STATUS_CODE;
        if (state) {
            status = NOTIFICATION_STATUS_CODE.AVRF;
        } else {
            // get the cancelled status string, updated using the whats new message type, can be AVR1 or AVR2
            const cancelledStatus = <NOTIFICATION_STATUS_CODE>notificationService.getCancelled(notificationModel);
            status = cancelledStatus ? cancelledStatus : NOTIFICATION_STATUS_CODE.AVR1;
        }

        return new CancellationModel(notificationModel, notificationUpdateKey, status);
    }
}
